import "./SkeletonVideo.scss";
export default function SkeletonVideo() {
  return (
    <div className="skeleton-video">
      <div className="skeleton-thumb" />
      <div className="skeleton-text" />
    </div>
  );
}
